import type { CSSProperties } from 'react';

import cx from 'classnames';

import STYLES from './SlidesIndicatorMobile.module.scss';

type Props = {
  length: number;
  activeIndex: number;
};

const SlidesIndicatorMobile = ({ activeIndex, length }: Props) => {
  if (length < 2) return null;

  // scroll starting from 3 dot until last 5, unless there are less than 5
  const activeDotIndex = Math.min(
    Math.max(0, activeIndex - 2),
    Math.max(0, length - 5),
  );

  return (
    <div className={STYLES.container}>
      <div
        className={STYLES.row}
        style={
          {
            '--scroll-index': activeDotIndex,
          } as CSSProperties
        }
      >
        {Array.from({ length }).map((_, index) => (
          <div
            className={cx({
              [STYLES.dot]: true,
              [STYLES.siblingToActive]:
                index === activeIndex - 1 || index === activeIndex + 1,
              [STYLES.active]: index === activeIndex,
            })}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export default SlidesIndicatorMobile;
